// Function to grow the specials container
let heights = new Array(),
    rows_shown = 0,
    height_to_add = 0,
    final_height = 0;

function check_button(){
    if(! (heights[rows_shown]) ){
        $('.load-more-properties').addClass('no-more');
    }
}

function add_rows (show_rows) {
    for(let i = 1; i <= show_rows; i++){
        if(heights[rows_shown]){
            height_to_add += heights[rows_shown];
            rows_shown += 1;
        }
    }
    check_button();
}

function adjust_size(el){
    final_height = 0;
    // get height of all row of properties
    heights = new Array();

    el.each(function(){
        heights.push($(this).outerHeight(true));
    });

    for(let i = 1; i <= rows_shown; i++){
        final_height += heights[ i - 1];
    }

    if(final_height > 0) {
        $('.properties-container').css('height', final_height);
    }
}

function view_more($el, $container, rows){
    // get height of all row of properties
    $el.each(function(){
        heights.push($(this).outerHeight(true));
    });

    add_rows(rows);

    final_height += height_to_add;

    if(final_height > 0) {
        $container.css('height', final_height);
    }

    check_button();

    $('.load-more-properties').on('click', function(e){
        e.preventDefault();

        height_to_add = 0;

        add_rows(rows);

        final_height += height_to_add;

        $container.animate({ 'height' : final_height }, 1000);
    });
}

$(window).on('load', function(){
    // Only allow when there are more than 3 rows
    if($('body').hasClass('single-property-location')){
        if($('.properties-inner').length > 3) {

            // Make sure no lazy loaded images are on page
            if($('img.lazy').length === 0){
                view_more($('.properties-inner'), $('.properties-container'), 2);
            } else {
                $('img.lazy').Lazy({
                    threshold: 2000,
                    onFinishedAll: function(){
                        $('.properties-container').addClass('active');
                        view_more($('.properties-inner'), $('.properties-container'), 2);
                    }
                });
            }
        } else {
            $('.load-more-properties').addClass('no-more');
        }
    }

    // New Posts
    if($('body').hasClass('news')){
        if($('.blog-post').length > 10) {
            $('.news-container').addClass('active');
            view_more($('.blog-post'), $('.news-container'), 10);
        } else {
            $('.load-more-properties').addClass('no-more');
        }
    }
});

$(window).resize(function() {
    if($('.properties-inner').length > 3) {
        setTimeout(function() {
            adjust_size($('.properties-inner'));
        }, 500);
    }

    if($('.blog-post').length > 10) {
        setTimeout(function() {
            adjust_size($('.blog-post'));
        }, 500);
    }
});